import { TimesheetsDataTable } from '@/components/(timesheets_table)/components/TimesheeetsDataTable'
import { timesheetsTableColumns } from '@/components/(timesheets_table)/components/timesheetsTableColumns'
import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Skeleton } from '@/components/ui/skeleton'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

export const Route = createFileRoute('/dashboard/employee/timesheets/')({
  component: RouteComponent,
})

function RouteComponent() {
  const api = useTRPC()
  const [pagination, setPagination] = useState({ page: 1, pageSize: 30 })

  const { data: timesheetsResult, isPending } = useQuery({
    ...api.timesheet.getTimesheetsMe.queryOptions({
      page: pagination.page,
      pageSize: pagination.pageSize,
    }),
  })

  const mainContents =
    isPending || !timesheetsResult ? (
      <Skeleton className="h-40 w-full" />
    ) : (
      <TimesheetsDataTable
        data={timesheetsResult.data}
        columns={timesheetsTableColumns}
        pagination={timesheetsResult.pagination}
        onPaginationChange={setPagination}
      />
    )

  return (
    <DashboardShell>
      <DashboardHeader heading="Timesheets" text="View your timesheets." />
      {mainContents}
    </DashboardShell>
  )
}
